import { render, staticRenderFns } from "./roundTextStyle.vue?vue&type=template&id=b6389276&"
import script from "./roundTextStyle.vue?vue&type=script&lang=ts&"
export * from "./roundTextStyle.vue?vue&type=script&lang=ts&"
import style0 from "./roundTextStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports